import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { ISubproject } from 'views/ProFormaTable/types';

interface ICreateSubprojectData {
    projectName: string;
    saleDate: string;
    developmentSiteName?: string;
    existingDevelopmentSiteUuid?: string;
}

interface ICreateSubprojectFromProFormaParams {
    organizationId: string;
    proFormaId: number;
    dealId: number;
    data: ICreateSubprojectData;
}

const createSubprojectFromProForma = async ({
    organizationId,
    proFormaId,
    dealId,
    data,
}: ICreateSubprojectFromProFormaParams): Promise<ISubproject> => {
    const response = await axiosInstance.post(
        API_ENDPOINTS.CREATE_SUBPROJECT_FROM_PRO_FORMA(dealId, organizationId, proFormaId),
        {
            projectName: data.projectName,
            saleDate: data.saleDate,
            developmentSiteName: data.developmentSiteName,
            existingDevelopmentSiteUuid: data.existingDevelopmentSiteUuid,
        },
    );
    return response.data;
};

export const useCreateSubprojectFromProForma = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: createSubprojectFromProForma,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['organization-projects'] });
            queryClient.invalidateQueries({ queryKey: ['getProFormas'] });
            queryClient.invalidateQueries({ queryKey: ['proFormaData'] });
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.DEVELOPMENT_PROJECTS] });
        },
        onError: error => {
            console.error('Error creating subproject from pro forma:', error);
        },
    });
};
